import React from 'react';

import MaxWidth from '@/components/common/layout/MaxWidth';
import PageNavigation from '@/components/common/PageNavigation';

import css from './TopNavigation.module.css';

const anchors = [
  { anchor: '#accommodations', label: 'Accommodations' },
  {
    anchor: '#alerts',
    label: 'Alerts',
  },
  {
    anchor: '#rentals',
    label: 'Rentals',
  },
  {
    anchor: '#transportation',
    label: 'Transportation',
  },
  {
    anchor: '#map',
    label: 'Map',
  },
  {
    anchor: '#campsites',
    label: 'Campsites',
  },
  {
    anchor: '#activities',
    label: 'Activities',
  },
];

const TopNavigation: React.FC = () => {
  return (
    <div className={css.navigation}>
      <MaxWidth className={`${css.innerWrapper} justify-left`}>
        <PageNavigation anchors={anchors} activeClass={css.active} />
      </MaxWidth>
    </div>
  );
};

export default TopNavigation;
